import { API } from '../../api';
import { axiosInstance } from '../../utils/fetcher';

const CancelToken = axiosInstance.CancelToken;

let getShipmentPreBookingInfoServiceCancelToken = () => {};
export const getShipmentPreBookingInfoService = (data) => {
  getShipmentPreBookingInfoServiceCancelToken();
  return axiosInstance.request({
    url: `${API.POV}/GetShipmentInformation`,
    method: 'post',
    data: data,
    cancelToken: new CancelToken(function executor(c) {
      getShipmentPreBookingInfoServiceCancelToken = c;
    }),
  });
};
